module.exports = __webpack_public_path__ + "img/services-3.cfbaca4e.jpg";